import React, { useEffect, useRef, useState } from 'react';
import GridSpace from './GridSpace';
import GridFill from './GridFill';

type Props = {};

export default function Approval({}: Props) {
	const soundRef = useRef<HTMLAudioElement | null>(null);
	const [isPlaying, setIsPlaying] = useState<boolean>(true);

	const [nVal, setNVal] = useState<number>(0);

	const [heart, setHeart] = useState<JSX.Element>();

	useEffect(() => {
		const urlPrefix: string = 'https://ph4sm4-content.s3.eu-central-1.amazonaws.com';

		soundRef.current = new Audio(urlPrefix + '/media/leaves_are_falling_mine.mp4'); // Make sure file is in /public folder
	}, []);

	useEffect(() => {
		if (!soundRef.current) return;

		if (isPlaying) {
			soundRef.current.play().catch((err) => {
				console.error('Playback failed:', err);
			});
		} else {
			soundRef.current.pause();
		}
	}, [isPlaying]);

	function renderXSpaces(x: number, color = '') {
		const spaces: JSX.Element[] = [];

		for (let i = 0; i < x; i++) spaces.push(<GridSpace color={color} />);

		return spaces;
	}

	function renderXFills(x: number) {
		const spaces: JSX.Element[] = [];

		for (let i = 0; i < x; i++) spaces.push(<GridFill />);

		return spaces;
	}

	function generateHeart() {
		const numberOfRowsUnderMain = Math.floor(nVal / 2.0);

		const firstRow = (
			<div className="heart-row">
				{renderXSpaces(numberOfRowsUnderMain)}

				{renderXFills(nVal)}

				{renderXSpaces(nVal - 2)}

				{renderXFills(nVal)}
			</div>
		);

		const lowerRows: JSX.Element[] = [];

		for (let i = 0; i < numberOfRowsUnderMain; i++) {
			const row = (
				<div className="heart-row">
					{renderXSpaces(numberOfRowsUnderMain - 1 - i)}

					{renderXFills(1)}

					{renderXSpaces(nVal + i * 2, 'red')}

					{renderXFills(1)}

					{renderXSpaces(nVal - 2 - 2 * (i + 1))}

					{i !== numberOfRowsUnderMain - 1 ? renderXFills(1) : null}

					{renderXSpaces(nVal + i * 2, 'red')}

					{renderXFills(1)}
				</div>
			);
			lowerRows.push(row);
		}

		const numberOfRowsLowerSection = Math.floor(nVal / 2) * 4;
		console.log(numberOfRowsLowerSection);

		for (let i = 0; i < numberOfRowsLowerSection; i++) {
			const row = (
				<div className="heart-row">
					{renderXSpaces(i + 1)}
					{renderXFills(1)}
					{renderXSpaces(2 * nVal + (numberOfRowsLowerSection - 3) - 2 * (i + 1), 'red')}
					{i !== numberOfRowsLowerSection - 1 ? renderXFills(1) : null}
				</div>
			);
			lowerRows.push(row);
		}

		setHeart(
			<>
				{firstRow} {lowerRows}
			</>
		);
	}

	return (
		<>
			<div className="flex items-center gap-5">
				<span>
					Podaj n <strong>(nieparzyste)</strong>:
				</span>
				<input
					value={nVal}
					onChange={(e) => setNVal(parseInt(e.target.value))}
					type="number"
					className="bg-transparent border-2 border-customBlue rounded-md px-3 py-1"
				/>
				<button
					className={`pager-button ml-auto ${nVal % 2 === 0 ? 'opacity-50 pointer-events-none' : 'opacity-100'}`}
					disabled={nVal % 2 === 0}
					onClick={generateHeart}>
					Generuj
				</button>
			</div>

			<div className="overflow-x-auto w-full">{heart}</div>

			<button
				className="pager-button w-fit mx-auto"
				onClick={() => {
					setIsPlaying(!isPlaying);
				}}>
				{isPlaying ? 'Chwila przerwy od słuchania' : 'Słuchaj dalej'}
			</button>
		</>
	);
}
